export default __webpack_public_path__ + "static/media/strong-health-joint.74c8bdcd.png";